export const ProductDesignSpecFieldLabels = {
  title: 'Title',
  description: 'Description',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  assignUserNeed: 'Assign User Need Reference',
  attachment: 'Attachments',
  components: 'Components',
  release: 'Release'
} as const;

export type ProductDesignSpecField = keyof typeof ProductDesignSpecFieldLabels;

export const ProductDesignSpecFields: ProductDesignSpecField[] = Object.keys(
  ProductDesignSpecFieldLabels
) as ProductDesignSpecField[];
